// eslint-disable-next-line import/prefer-default-export
export const IIV_ERROR = {
  INIT_FAILED: {
    code: 113821,
    name: 'INIT_FAILED',
    message: 'IIV 페이지 초기화 실패',
  },
}
